import React, {Fragment, useEffect, useState} from "react";
import Cookies from 'js-cookie';
import {useSearchParams} from "react-router-dom";
import ErrorPage from "../pages/payment/misa/ErrorPage";
import Http from "../HttpOnly";
import {BankHubUrl} from "../config/BankhubUrl";

const Auth = ({children}) => {
    const [isError, setIsError] = useState(false)
    let [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {
        if(!Cookies.get('isLogin') || Cookies.get('isLogin') === undefined) {
            setIsError(true)
            Http.get(BankHubUrl.callBackUrl, {
                params: {
                    clientId: searchParams.get("client_id")
                },
                baseURL: process.env.REACT_APP_SHB_LINK
            }).then(reCall => {
                const objCallBack = reCall.data.data
                var urlError = objCallBack.failureCb
                urlError = urlError.replace('%7Bcode%7D', 'CANCEL')
                urlError = urlError.replace('%7Bmessage%7D', 'CANCEL')
                setTimeout(() => {
                    window.location.replace(urlError)
                }, 5000)

            })
        }
    }, [])

    return (
        <Fragment>
            { isError ? <ErrorPage/> : children}
        </Fragment>
    )
}

export default Auth
